import EZFileLogo from '@/assets/img/ez-file-logo';
import { Flex, Stack, Text } from '@mantine/core';

export const FinancialAidHero = () => (
  <Stack
    spacing={20}
    maw={620}
  >
    <Flex
      align="center"
      gap={10}
      wrap="wrap"
    >
      <Text
        size={36}
        c="white"
        fw={700}
      >
        You qualify for
      </Text>
      <EZFileLogo width={110} />
      <Text
        size={36}
        c="white"
        fw={700}
      >
        !
      </Text>
    </Flex>
    <Text
      size={16}
      c="white"
    >
      Based on the income and household size you shared, you{' '}
      <Text
        span
        fs="italic"
        inherit
      >
        should
      </Text>{' '}
      qualify for Financial Aid from the hospital.
    </Text>
    <Text
      size={16}
      c="white"
    >
      Complete the Resolve EZ File form in less than 15 minutes to find out what type of financial
      aid you&apos;re eligible for. We&apos;ll take care of the rest of the financial aid
      application process.
    </Text>
  </Stack>
);
